(function () {
  var root = document.querySelector('.sq[data-quiz]');
  if (!root) return;
  var code = root.getAttribute('data-code') || '';
  var $ = function (s) { return root.querySelector(s); };
  var views = { questions: $('[data-view=questions]'), gate: $('[data-view=gate]'), result: $('[data-view=result]') };

  var QUESTIONS = [
    { key: 'type', q: 'What is your skin type?', opts: [
      ['Dry', 'Feels tight, flaky or rough', 'Dry skin'],
      ['Oily', 'Shiny by midday, visible pores', 'Oily skin'],
      ['Combination', 'Oily T-zone, drier cheeks', 'Combination skin'],
      ['Sensitive', 'Stings or turns red easily', 'Sensitive skin'],
      ['Normal', 'Balanced, few problems', 'Normal skin'] ] },
    { key: 'concern', q: 'What would you most like to improve?', opts: [
      ['Breakouts', 'Pimples and blemishes', 'Acne & breakouts'],
      ['Dryness', 'Dehydrated, tight skin', 'Dryness & dehydration'],
      ['Dullness and dark spots', 'Uneven tone, tired look', 'Dullness & uneven tone'],
      ['Redness', 'Irritated or reactive skin', 'Redness & sensitivity'],
      ['Fine lines and firmness', 'Bouncy, smoother-looking skin', 'Fine lines & firmness'],
      ['Pores and oil', 'Shine and visible pores', 'Pores & oil control'] ] },
    { key: 'size', q: 'How big should your routine be?', opts: [
      ['Simple', '3 steps: cleanse, treat, moisturize', 'simple'],
      ['Standard', '5 steps, including toner and sunscreen', 'standard'],
      ['Full Korean routine', '7 steps for the whole ritual', 'full'] ] },
    { key: 'budget', q: 'What is your budget per product?', opts: [
      ['Under $25', 'Best value picks', '25'],
      ['Up to $35', 'Most popular range', '35'],
      ['Any price', 'Show me the best match', '999'] ] },
    { key: 'devices', q: 'Interested in at-home beauty devices?', opts: [
      ['Yes', 'Show me devices too', 'yes'],
      ['Not now', 'Skincare only', 'no'] ] }
  ];

  var STEP_SETS = {
    simple: [['Cleanse', 'foam-gel-cleansers'], ['Treat', 'serums-ampoules'], ['Moisturize', 'moisturizers-creams']],
    standard: [['Cleanse', 'foam-gel-cleansers'], ['Tone', 'toners'], ['Treat', 'serums-ampoules'], ['Moisturize', 'moisturizers-creams'], ['Protect', 'sunscreen']],
    full: [['Oil cleanse', 'oil-cleansers-balms'], ['Cleanse', 'foam-gel-cleansers'], ['Tone', 'toners'], ['Treat', 'serums-ampoules'], ['Eyes', 'eye-care'], ['Moisturize', 'moisturizers-creams'], ['Protect', 'sunscreen']]
  };

  var CONCERN_COLLECTIONS = { 'Acne & breakouts': 'acne-breakouts', 'Dryness & dehydration': 'dryness-dehydration', 'Dullness & uneven tone': 'dullness-uneven-tone', 'Redness & sensitivity': 'redness-sensitivity', 'Fine lines & firmness': 'fine-lines-firmness', 'Pores & oil control': 'pores-oil-control' };

  var answers = {}, idx = 0;
  var STORE = 'osss_quiz';

  function currencyCode() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; }
  function rate() { return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1; }

  function show(name) {
    Object.keys(views).forEach(function (k) { views[k].hidden = k !== name; });
    var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function renderQuestion() {
    var item = QUESTIONS[idx];
    $('[data-progress]').textContent = 'Question ' + (idx + 1) + ' of ' + QUESTIONS.length;
    $('[data-bar]').style.width = (idx / QUESTIONS.length * 100) + '%';
    $('[data-question]').textContent = item.q;
    var box = $('[data-options]');
    box.innerHTML = '';
    item.opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sq__opt';
      b.innerHTML = '<strong></strong><span></span>';
      b.querySelector('strong').textContent = o[0];
      b.querySelector('span').textContent = o[1];
      b.addEventListener('click', function () {
        answers[item.key] = o[2];
        if (idx < QUESTIONS.length - 1) { idx++; renderQuestion(); }
        else { try { sessionStorage.setItem(STORE, JSON.stringify(answers)); } catch (e) {} show('gate'); }
      });
      box.appendChild(b);
    });
    $('[data-back]').hidden = idx === 0;
  }

  // The collection JSON already returns prices in the shopper's currency.
  function money(v) {
    var cur = currencyCode();
    try { return new Intl.NumberFormat('en-CA', { style: 'currency', currency: cur }).format(v) + ' ' + cur; }
    catch (e) { return '$' + v.toFixed(2) + ' ' + cur; }
  }

  function fetchCollection(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }

  function tagsOf(p) {
    var t = p.tags || [];
    return typeof t === 'string' ? t.split(',').map(function (x) { return x.trim(); }) : t;
  }

  function score(p) {
    var tags = tagsOf(p), s = 0;
    if (tags.indexOf(answers.concern) > -1) s += 4;
    if (tags.indexOf(answers.type) > -1) s += 3;
    if (tags.indexOf('Bestseller') > -1) s += 2;
    if (tags.indexOf('Trending in Korea') > -1) s += 1;
    if (tags.indexOf('New Arrival') > -1) s += 1;
    return s;
  }

  function price(p) { return parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0); }
  function inStock(p) { return (p.variants || []).some(function (v) { return v.available; }); }

  function pick(products, used) {
    var max = (parseFloat(answers.budget) || 999) * rate();
    var ok = products.filter(function (p) { return inStock(p) && !used[p.id]; });
    var within = ok.filter(function (p) { return price(p) <= max; });
    var pool = within.length ? within : ok;
    pool.sort(function (a, b) { return score(b) - score(a) || price(a) - price(b); });
    return pool[0] || null;
  }

  function card(label, p) {
    var a = document.createElement('a');
    a.className = 'sq__card';
    a.href = '/products/' + p.handle;
    a.innerHTML = '<img loading="lazy" alt=""><div><span class="sq__step"></span><span class="sq__name"></span><span class="sq__price"></span></div>';
    var src = p.images && p.images[0] ? p.images[0].src : '';
    if (src) a.querySelector('img').src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=480';
    a.querySelector('img').alt = p.title;
    a.querySelector('.sq__step').textContent = label;
    a.querySelector('.sq__name').textContent = p.title;
    a.querySelector('.sq__price').textContent = money(price(p));
    return a;
  }

  function showResult(withCode) {
    show('result');
    var steps = STEP_SETS[answers.size] || STEP_SETS.standard;
    $('[data-result-title]').textContent = 'Your routine for ' + (answers.type || 'your skin').toLowerCase();
    $('[data-result-sub]').textContent = 'Picked for ' + (answers.concern || 'your skin').toLowerCase() + '. Start with the first step and add the rest as you go.';
    var more = $('[data-more-link]');
    more.href = '/collections/' + (CONCERN_COLLECTIONS[answers.concern] || 'skincare');
    more.textContent = 'Shop all ' + (answers.concern || 'skincare').toLowerCase();
    var box = $('[data-code-box]');
    if (withCode && code) { box.hidden = false; $('[data-code-text]').textContent = code; } else { box.hidden = true; }
    var holder = $('[data-steps]');
    holder.innerHTML = '';
    var used = {};
    Promise.all(steps.map(function (s) { return fetchCollection(s[1]); })).then(function (lists) {
      steps.forEach(function (s, i) {
        var p = pick(lists[i], used);
        if (p) { used[p.id] = true; holder.appendChild(card(s[0], p)); }
      });
      if (!holder.children.length) holder.innerHTML = '<p>We could not load your picks right now. <a href="/collections/skincare">Browse all skincare</a>.</p>';
    });
    var dev = $('[data-devices]');
    if (answers.devices === 'yes') {
      fetchCollection('beauty-devices').then(function (list) {
        var cards = $('[data-device-cards]');
        cards.innerHTML = '';
        list.filter(inStock).sort(function (a, b) { return score(b) - score(a) || price(a) - price(b); }).slice(0, 3).forEach(function (p) { cards.appendChild(card('Device', p)); });
        dev.hidden = !cards.children.length;
      });
    } else { dev.hidden = true; }
  }

  $('[data-back]').addEventListener('click', function () { if (idx > 0) { idx--; renderQuestion(); } });
  $('[data-skip]').addEventListener('click', function () { showResult(false); });
  $('[data-restart]').addEventListener('click', function () {
    answers = {}; idx = 0;
    try { sessionStorage.removeItem(STORE); } catch (e) {}
    renderQuestion(); show('questions');
  });

  var form = root.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok || /challenge|login/.test(r.url)) throw new Error('fallback');
          showResult(true);
        })
        .catch(function () { form.submit(); });
    });
  }

  var returned = /customer_posted=true/.test(location.search);
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) {}
  if (returned && saved && saved.type) { answers = saved; views.questions.hidden = true; showResult(true); }
  else { renderQuestion(); }
})();